import React from 'react'
import PropTypes from 'prop-types'
import { Column } from '@sainsburys-tech/bolt'
import { GetComponent } from '../../CMSComponents'
import C006 from '../../isolated/C006/C006'
import * as Styled from '../../isolated/M054/M054.styles'

/**
 * M054Grid is used for displaying M054 Accordion components in a stack arrangement.
 */
const dataTest = 'm054'
const M054Grid = ({ heading, included, textPosition }) => {
  if (included.length < 1) return null

  return (
    <Styled.GridContainer data-test={`${dataTest}-grid-container`} gutterValue={0} block='xs'>
      {heading && <C006 heading={heading} textPosition={textPosition} data-test={`${dataTest}-grid-heading`} />}
      {included.map((accordion, i) => (
        <Column data-test={`${dataTest}-accordion-container-${i}`} key={`m054-accordion-container-${i}`}>
          <GetComponent id={i} gridHeading={heading} {...accordion} />
        </Column>
      ))}
    </Styled.GridContainer>
  )
}

M054Grid.propTypes = {
  /** Optional heading to be displayed before the accordions */
  heading: PropTypes.string,
  /** Array of child accordion components (M054) to be rendered inside the grid */
  included: PropTypes.arrayOf(
    PropTypes.shape({
      bodyCopy: PropTypes.string,
      heading: PropTypes.string,
      type: PropTypes.string
    })
  ).isRequired,
  /** Optional prop for the text position of the main header. Defaults to center */
  textPosition: PropTypes.string
}

M054Grid.defaultProps = {
  heading: '',
  textPosition: 'center'
}

export default M054Grid
